"use client"
import { PostType } from '@/libs/types'
import React from 'react'
import CardCategoryOne from './CardCategory'

interface KnowledgeListProps {
    knowledges: Array<PostType>,
    locale: string
}
const KnowledgeList: React.FunctionComponent<KnowledgeListProps> = ({
    knowledges = [],
    locale
}) => {

    const [categories, _] = React.useState<any>(knowledges.map(({ attributes: post }: any) => ({ ...post?.category?.data }))?.filter((value: any, index: number, self: any) =>
        self.findIndex((s: any) => s.id === value?.id) as number === index
    ))

    if (knowledges.length === 0) return <></>;
    return (
        <div className="py-5 bg-light knowledges">
            <div className="container">
                <div className="row">
                    {categories && categories.map((category: any, index: number) => {

                        const cateKnowledges: Array<PostType> = knowledges.filter((knowledge: PostType) => knowledge.attributes.category?.data?.id === category?.id)

                        return (
                            <CardCategoryOne key={index}
                                knowledges={cateKnowledges}
                                category={category}
                                locale={locale} />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default KnowledgeList
